import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ProductShowcase() {
  const tomos = [{
    id: 'T1',
    icon: '📘',
    title: 'Tomo 1 — Orígenes del Sistema Agrario',
    desc: 'Economía colonial, pueblos originarios, primeras formas de producción, actores sociales, tierra y poder.'
  }, {
    id: 'T2',
    icon: '📗',
    title: 'Tomo 2 — Siglo XIX y Formación del Estado',
    desc: 'Expansión territorial, Campaña del Desierto, latifundio, colonización inmigrante, estancias, Grito de Alcorta.'
  }, {
    id: 'T3',
    icon: '📙',
    title: 'Tomo 3 — El Modelo Agroexportador',
    desc: 'El granero del mundo, inmigración masiva, ferrocarriles, frigoríficos, producción agrícola, contradicciones del modelo.'
  }, {
    id: 'T4',
    icon: '📕',
    title: 'Tomo 4 — Crisis y Transformaciones',
    desc: 'Gran Depresión, impacto en el agro, golpe de 1930, migraciones internas, inicio de la industrialización.'
  }, {
    id: 'T5',
    icon: '📓',
    title: 'Tomo 5 — Intervención del Estado',
    desc: 'Peronismo y agro, IAPI, Estatuto del Peón Rural, derechos laborales, políticas agrarias, debate histórico.'
  }, {
    id: 'T6',
    icon: '📔',
    title: 'Tomo 6 — Agro Actual y Nuevos Modelos',
    desc: 'Sojización, agronegocio, conflicto 2008, agricultura familiar, soberanía alimentaria, tecnología y ambiente.'
  }];
  const includes = ['Introducción clara para el docente', 'Explicación del contenido en lenguaje simple', 'Ejemplos concretos del contexto argentino y rural', 'Actividades listas para usar: individual y grupal', 'Preguntas guía por módulo', 'Evaluación completa con opción múltiple, desarrollo y análisis', 'Criterios de corrección y rúbricas', 'Recursos visuales sugeridos: mapas, cuadros, esquemas', 'Adaptaciones para ciclo básico y orientado', 'Secuencia didáctica lista: 2, 4, 8 y 12 clases'];
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <div className="text-center mb-8" data-id="element-162">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-163">
            🏆 KIT COMPLETO HISTORIA AGRARIA LISTA
          </h2>
          <p className="text-lg md:text-xl font-bold text-brand-accent neon-glow" data-id="element-164">
            6 Tomos + 4 Bonos — Colonia → Actualidad
          </p>
          <p className="text-sm md:text-base text-gray-500 mt-1 font-medium" data-id="element-165">
            +400 páginas — Todo resuelto.
          </p>
        </div>

        {/* Visual Tabs */}
        <div className="flex justify-between bg-brand-dark rounded-lg border border-white/10 p-1.5 mb-8 overflow-hidden" data-id="element-166">
          {['Orígenes', 'Siglo XIX', 'Agroexport.', 'Crisis', 'Estado', 'Agro Actual'].map((label, i) => <div key={i} className="flex-1 text-center py-1.5 px-0.5 border-r last:border-r-0 border-white/5" data-id="element-167">
              <div className="font-bold text-brand-accent text-xs" data-id="element-168">
                T{i + 1}
              </div>
              <div className="text-[9px] md:text-xs font-medium text-gray-500 truncate" data-id="element-169">
                {label}
              </div>
            </div>)}
        </div>

        <div className="text-center mb-6" data-id="element-170">
          <h3 className="text-xl font-black text-white inline-flex items-center bg-brand-accent px-4 py-1.5 rounded-lg" data-id="element-171">
            🌾 6 TOMOS COMPLETOS
          </h3>
          <p className="text-sm md:text-base font-bold text-gray-500 mt-2" data-id="element-172">
            Colonia → Siglo XXI
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-173">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-dark border border-white/10 rounded-xl p-4 md:p-5 hover:border-brand-accent/30 transition-colors" data-id="element-174">
              <h4 className="text-lg font-bold text-white mb-2 flex items-start" data-id="element-175">
                <span className="text-xl mr-2 leading-none" data-id="element-176">{tomo.icon}</span>
                <span data-id="element-177">{tomo.title}</span>
              </h4>
              <p className="text-sm text-gray-400 leading-relaxed ml-7" data-id="element-178">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-dark rounded-xl border border-white/10 overflow-hidden" data-id="element-179">
          <div className="bg-brand-accent py-3 px-4 text-center" data-id="element-180">
            <h4 className="text-lg md:text-xl font-bold text-white" data-id="element-181">
              Cada tomo incluye:
            </h4>
          </div>
          <div className="p-4 md:p-6" data-id="element-182">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6" data-id="element-183">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-184">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent mr-2.5 shrink-0" data-id="element-185" />
                  <span className="text-sm text-gray-300 font-medium" data-id="element-186">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}